import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // ✅ Check localStorage on load
  useEffect(() => {
    const token = localStorage.getItem("tokenString");
    setIsAuthenticated(!!token);
  }, []);

  // ✅ Save token to localStorage
  const login = (token) => {
    localStorage.setItem("tokenString", token);
    setIsAuthenticated(true);
  };

  // ✅ Remove session on logout
  const logout = () => {
    localStorage.removeItem("tokenString");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
